export const videosData = [
    {
        id: 1,
        iframe: "https://www.youtube.com/embed/fe2yZ1A3b6g",
        description: "Cómo gestionar las ventas desde el CRM para mantener un control sobre tus ciclos de venta.",
    },
    {
        id: 2,
        iframe: "https://www.youtube.com/embed/XVpz7oJL71c",
        description: "Cómo configurar productos y servicios teniendo en cuenta los lotes o números de serie únicos.",
    },
    // {
    //     id: 3,
    //     iframe: "https://www.youtube.com/embed/FM4vshatyWg",
    //     description: "Todo lo que debes saber sobre la ficha de pacientes.",
    // },
    {
        id: 4,
        iframe: "https://www.youtube.com/embed/1vQ17B1YBZ4",
        description: "Cómo gestionar una reparación. Control de garantías y servicio técnico.",
    },
    {
        id: 5,
        iframe: "https://www.youtube.com/embed/2V6iY67Af64",
        description: "Descubre el modelo de gestión Multicentro. Control de varios centros de manera simultánea y desde una única herramienta.",
    },
    {
        id: 6,
        iframe: "https://www.youtube.com/embed/_icM23ziiFU",
        description: "Aprende a crear tu pedido de compra para reabastecer tu stock. Controla las compras a tus proveedores.",
    },
    {
        id: 7,
        iframe: "https://www.youtube.com/embed/d3dMCWoUTeI",
        description: "Cómo usar el punto de venta para generar venta rápida y factura simplificada."
    },
    {
        id: 8,
        iframe: "https://www.youtube.com/embed/64xBDA8V7eQ",
        description: "Aprende a generar informes y analítica para mejorar tus ventas."
    },
    {
        id: 9,
        iframe: "https://www.youtube.com/embed/huPci5BYFeI",
        description: "En este video veremos cómo ajustar el inventario de uno de nuestros centros siendo administradores gracias a las peticiones de ajuste que pueden solicitar los usuarios sin permisos de inventario."
    },

]